import logoSantaLucia from "@/assets/clients/hospital-santa-lucia.webp";
import logoSmartFit from "@/assets/clients/smart-fit.webp";
import logoSubway from "@/assets/clients/subway.webp";
import logoCacauShow from "@/assets/clients/cacau-show.webp";
import logoBurgerKing from "@/assets/clients/burger-king.webp";
import logoHabibs from "@/assets/clients/habibs.webp";
import logoBancoBrasil from "@/assets/clients/banco-brasil.webp";
import logoBradesco from "@/assets/clients/bradesco.webp";
import logoLatam from "@/assets/clients/latam.webp";
import logoBRB from "@/assets/clients/brb.webp";
import logoMarinha from "@/assets/clients/marinha.webp";
import logoEncore from "@/assets/clients/hospital-encore.webp";
import logoIRG from "@/assets/clients/irg-hospital.webp";
import logoClaro from "@/assets/clients/claro.webp";
import logoPoupex from "@/assets/clients/fhe-poupex.webp";

const clients = [
  { src: logoSantaLucia, alt: "Hospital Santa Lúcia" },
  { src: logoSmartFit, alt: "Smart Fit" },
  { src: logoSubway, alt: "Subway" },
  { src: logoCacauShow, alt: "Cacau Show" },
  { src: logoBurgerKing, alt: "Burger King" },
  { src: logoHabibs, alt: "Habib's" },
  { src: logoBancoBrasil, alt: "Banco do Brasil" },
  { src: logoBradesco, alt: "Bradesco" },
  { src: logoBRB, alt: "Banco BRB" },
  { src: logoMarinha, alt: "Marinha do Brasil" },
  { src: logoEncore, alt: "Hospital Encore" },
  { src: logoIRG, alt: "IRG Hospital" },
  { src: logoLatam, alt: "Latam Airlines" },
  { src: logoClaro, alt: "Claro" },
  { src: logoPoupex, alt: "FHE POUPEX" },
];

const ClientLogos = () => (
  <section className="py-12 md:py-16">
    <div className="container mx-auto px-4">
      <p className="text-center text-sm uppercase tracking-[0.2em] text-muted-foreground mb-8">
        Empresas que confiam na USA
      </p>
      <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
        {clients.map((logo) => (
          <img
            key={logo.alt}
            src={logo.src}
            alt={logo.alt}
            className="h-12 md:h-14 object-contain grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
            loading="lazy"
            width={120}
            height={56}
            decoding="async"
          />
        ))}
      </div>
    </div>
  </section>
);

export default ClientLogos;
